import * as api from '../api';
import { SNACKBAR_DURATION_MS, getSnackbarColor } from "../utils/snackbar";

// Action Types
export const GET_LAW_CASES = 'GET_LAW_CASES';
export const GET_LAW_CASE = 'GET_LAW_CASE';
export const CREATE_LAW_CASE = 'CREATE_LAW_CASE';
export const UPDATE_LAW_CASE = 'UPDATE_LAW_CASE';
export const DELETE_LAW_CASE = 'DELETE_LAW_CASE';
export const CLOSE_LAW_CASE = 'CLOSE_LAW_CASE';
export const GET_CASE_DASHBOARD = 'GET_CASE_DASHBOARD';
export const PERFORM_CONFLICT_CHECK = 'PERFORM_CONFLICT_CHECK';

// Get all cases
export const getLawCases = (searchQuery, page, pageSize) => async (dispatch) => {
  try {
    const { data } = await api.fetchLawCases(searchQuery, page, pageSize);

    dispatch({
      type: GET_LAW_CASES,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching law cases:', error);
    throw error;
  }
};

// Get single case
export const getLawCase = (id) => async (dispatch) => {
  try {
    const { data } = await api.fetchLawCase(id);

    dispatch({
      type: GET_LAW_CASE,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching law case:', error);
    throw error;
  }
};

// Create case
export const createLawCase = (caseData, openSnackbar, history, currentLang) => async (dispatch) => {
  try {
    const { data } = await api.createLawCase(caseData);

    dispatch({
      type: CREATE_LAW_CASE,
      payload: data
    });

    openSnackbar('Case created successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Case created successfully"));
    history.push(`/${currentLang}/app/law-firm/cases/${data._id}`);

    return data;
  } catch (error) {
    console.error('Error creating law case:', error);
    openSnackbar('Error creating case', SNACKBAR_DURATION_MS, getSnackbarColor("Error creating case"));
    throw error;
  }
};

// Update case
export const updateLawCase = (id, caseData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.updateLawCase(id, caseData);

    dispatch({
      type: UPDATE_LAW_CASE,
      payload: data
    });

    openSnackbar('Case updated successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Case updated successfully"));

    return data;
  } catch (error) {
    console.error('Error updating law case:', error);
    openSnackbar('Error updating case', SNACKBAR_DURATION_MS, getSnackbarColor("Error updating case"));
    throw error;
  }
};

// Delete case
export const deleteLawCase = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteLawCase(id);

    dispatch({
      type: DELETE_LAW_CASE,
      payload: id
    });

    openSnackbar('Case deleted successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Case deleted successfully"));
  } catch (error) {
    console.error('Error deleting law case:', error);
    openSnackbar('Error deleting case', SNACKBAR_DURATION_MS, getSnackbarColor("Error deleting case"));
    throw error;
  }
};

// Close case
export const closeLawCase = (id, closeData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.closeLawCase(id, closeData);

    dispatch({
      type: CLOSE_LAW_CASE,
      payload: data
    });

    openSnackbar('Case closed successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Case closed successfully"));

    return data;
  } catch (error) {
    console.error('Error closing case:', error);
    openSnackbar('Error closing case', SNACKBAR_DURATION_MS, getSnackbarColor("Error closing case"));
    throw error;
  }
};

// Get case dashboard
export const getCaseDashboard = (id) => async (dispatch) => {
  try {
    const { data } = await api.getCaseDashboard(id);

    dispatch({
      type: GET_CASE_DASHBOARD,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error fetching case dashboard:', error);
    throw error;
  }
};

// Perform conflict check
export const performConflictCheck = (conflictData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.performConflictCheck(conflictData);

    dispatch({
      type: PERFORM_CONFLICT_CHECK,
      payload: data
    });

    return data;
  } catch (error) {
    console.error('Error performing conflict check:', error);
    openSnackbar('Error performing conflict check', SNACKBAR_DURATION_MS, getSnackbarColor("Error performing conflict check"));
    throw error;
  }
};

// Add task
export const addCaseTask = (caseId, taskData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addCaseTask(caseId, taskData);

    dispatch({
      type: UPDATE_LAW_CASE,
      payload: data
    });

    openSnackbar('Task added successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Task added successfully"));

    return data;
  } catch (error) {
    console.error('Error adding task:', error);
    openSnackbar('Error adding task', SNACKBAR_DURATION_MS, getSnackbarColor("Error adding task"));
    throw error;
  }
};

// Add note
export const addCaseNote = (caseId, noteData, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addCaseNote(caseId, noteData);

    dispatch({
      type: UPDATE_LAW_CASE,
      payload: data
    });

    openSnackbar('Note added successfully', SNACKBAR_DURATION_MS, getSnackbarColor("Note added successfully"));

    return data;
  } catch (error) {
    console.error('Error adding note:', error);
    openSnackbar('Error adding note', SNACKBAR_DURATION_MS, getSnackbarColor("Error adding note"));
    throw error;
  }
};
